import type { Client, ClientHeaders } from "@medusajs/js-sdk";

export class OrderSet {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  /**
   * Creates an empty order set for the authenticated customer.
   * Used before multi-cart checkout to get an order_set_id that
   * each cart completion will link to.
   *
   * @param headers - Optional headers to pass in the request.
   * @returns The created order set with id and display_id.
   *
   * @example
   * ```ts
   * const { order_set } = await sdk.store.orderSet.create();
   * // order_set.id => "ordset_abc123"
   * ```
   */
  create = async (
    headers?: ClientHeaders
  ): Promise<{
    order_set: { id: string; display_id: number; customer_id: string };
  }> => {
    return this.client.fetch("/store/order-set", {
      method: "POST",
      headers
    });
  };
}
